import { render, staticRenderFns } from "./MAN906P01.vue?vue&type=template&id=40787f28&"
import script from "./MAN906P01.vue?vue&type=script&lang=js&"
export * from "./MAN906P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports